<template>
  <div class="active-locations-report">
    <div class="header-section">
      <div class="container">
        <h1 class="main-title">
          <i class="fas fa-map-marker-alt"></i>
          Active Locations Report
        </h1>
        <p class="subtitle">
          FranConnect-synced locations for project {{ projectId }} — presets match CO-Verify FC reporting
        </p>
        <FranchiseLocationsPanel
          v-if="projectId"
          :project-id="projectId"
          show-project-input
          :show-stats="true"
        />
        <div v-else-if="accessDenied" class="access-denied">
          <p>Active locations are only available for organizations with FranConnect sync configured.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import FranchiseLocationsPanel from '@/components/franchise/FranchiseLocationsPanel.vue'
import franchiseHubContext from '@/services/franchiseHubContext'

const projectId = ref(null)
const accessDenied = ref(false)
const router = useRouter()

onMounted(async () => {
  const ctx = await franchiseHubContext.load()
  if (ctx.hub_enabled && ctx.project_id) {
    router.replace({
      path: franchiseHubContext.getHubPath(ctx.project_id),
      query: { tab: 'locations' },
    })
    return
  }
  if (ctx.project_id) {
    projectId.value = ctx.project_id
  } else {
    accessDenied.value = true
  }
})
</script>

<style scoped>
.active-locations-report {
  min-height: 100vh;
  background: linear-gradient(135deg, #0f766e 0%, #115e59 100%);
}

.header-section {
  padding: 2rem 0;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
}

.main-title {
  color: white;
  font-size: 2.25rem;
  margin: 0 0 0.5rem;
}

.subtitle {
  color: rgba(255, 255, 255, 0.85);
  margin: 0 0 1rem;
}

.access-denied {
  color: white;
  padding: 2rem 0;
}
</style>
